import shopComparator from '@core/utils/sort/shopComparator';
import Shop from '@models/country/Shop';

export function sortShops(shops: Shop[]) {
    return [...shops].sort(shopComparator);
}
